import type { InvoiceRowData } from "@/components/shared/data-table";
import { InvoiceStatus } from "@/lib/constants/invoiceStatus";
import { confColor } from "@/lib/miscellaneous/confidence-color";
import { cn } from "@/lib/utils";
import type { CellContext } from "@tanstack/react-table";

type Props = CellContext<InvoiceRowData, unknown> & {
  showConfidence?: boolean;
};

export const InvoiceNumberCell = ({ row, showConfidence = false }: Props) => {
  if (
    row.original.invoice.status === InvoiceStatus.NEW ||
    row.original.invoice.status === InvoiceStatus.ERROR ||
    !row.original.invoice.isBooking ||
    !row.original.invoice.invoiceNo
  ) {
    return null;
  }

  return (
    <div className={cn("flex justify-start")}>
      <span
        className={cn(
          "rounded p-1",
          confColor(
            showConfidence
              ? row.original.invoice.invoiceNoConfidence
              : undefined,
          ),
        )}
      >
        {row.original.invoice.invoiceNo}
      </span>
    </div>
  );
};
